import {
  Box,
  BoxProps,
  IconButton,
  Typography,
  TypographyProps,
} from "@mui/material";
import { ReactComponent as ArrowLeft } from "../../../../common/icons/arrowLeft.svg";

type Props = {
  title: string;
  titleProps?: TypographyProps;
  containerProps?: BoxProps;
  onBackClick: () => void;
};

const TitleWithBackButton = ({
  title,
  titleProps,
  containerProps,
  onBackClick,
}: Props) => {
  return (
    <Box display="flex" alignItems="center" {...containerProps}>
      <IconButton onClick={onBackClick}>
        <ArrowLeft style={{ width: "24px", height: "24px" }} />
      </IconButton>
      <Typography
        variant="header"
        sx={{
          fontWeight: 600,
          fontSize: "32px",
        }}
        {...titleProps}
      >
        {title}
      </Typography>
    </Box>
  );
};

export default TitleWithBackButton;
